import { lazy } from 'react';

export const RichTextEditor = lazy(() => import('./RichTextEditorImpl').then((m) => ({ default: m.RichTextEditor })));
